import Password from "./password";

export default Password